import { FileModel } from "@aecom/core";
import { Component, Input, OnInit, inject, input, output } from "@angular/core";
import RFIRole from "@models/rfiRoles";
import RFIStatus from "@models/rfiStatus";
import LocalContractUserService from "@services/local-contractUser.service";
import LocalUserService from "@services/local-user.service";
import { combineUserInfo, getWorkflowStatusArray } from "@shared/utils";
import { DefaultSelection36RfiReviewerPayload, DefaultSelection36RfiWatcherPayload, IPRFIDocumentDownload, IPRFIItem, IUser } from "src/app/api-generated";
import { Router } from "@angular/router";
import BaseFunctionService from "@services/baseFunction.service";
import { AuthService } from "@bbj/components";

@Component({
  selector: "leftPanel",
  templateUrl: "./leftPanel.component.html",
  standalone: false
})
export default class LeftPanelComponent implements OnInit {
  authService = inject(AuthService);
  localContractUserService = inject(LocalContractUserService);
  localUserService = inject(LocalUserService);
  private router = inject(Router);
  baseFunctionService = inject(BaseFunctionService);

  readonly defaultTab = input("details");

  readonly allowMovingFiles = input(false);

  @Input() reviewersResponse: (DefaultSelection36RfiReviewerPayload & {UserInfo?: IUser})[] = [];

  @Input() watchersResponse: (DefaultSelection36RfiWatcherPayload & {UserInfo?: IUser})[] = [];

  readonly moveAttachment = output<FileModel>();

  readonly moveAttachments = output<FileModel[]>();

  entity: IPRFIItem;

  docs: IPRFIDocumentDownload[];

  IsDbAdmin = false;

  showProcessing = false;

  showResponseTab = false;

  isCompile = false;
  
  ngOnInit(): void {
    this.entity = this.baseFunctionService.getEntity();
    this.docs = this.baseFunctionService.getDocs();
    const role = this.localContractUserService.currentUserContractRole;
    const userId = this.authService.getUserId();
    // DB User shares the read-only DB-side view, so treat it as DB Admin here.
    this.IsDbAdmin = role === RFIRole.DBAdmin || role === RFIRole.DBUser;
    this.isCompile = this.entity.Status === RFIStatus.Review_Period && userId === this.entity.CoordinatorId && this.router.url.includes('compilingResponse');

    if(!this.IsDbAdmin)
    {
      this.showProcessing = true;
      const users = this.localUserService.getItems();
      this.reviewersResponse = this.entity.rfi_reviewer.map((item) => {
        const user = users.find((u)=>{return u.id === item.ReviewerId});
        return combineUserInfo<DefaultSelection36RfiReviewerPayload>(item, user);
      });
      this.watchersResponse = this.entity.rfi_watcher.map((item) => {
        const user = users.find((u)=>{return u.id === item.WatcherId});
        return combineUserInfo<DefaultSelection36RfiWatcherPayload>(item, user);
      });
      this.showResponseTab = getWorkflowStatusArray(this.entity).includes(RFIStatus.Review_Period);
    }
    
  }

  attachmentOut(item: FileModel): void {
    // console.log(item);
    this.moveAttachment.emit(item);
  }

  attachmentsOut(items: FileModel[]): void {
    // console.log(item);
    this.moveAttachments.emit(items);
  }
}
